/**
 * Sets --vh to 1% of window.innerHeight (in px) for calc()-based layout.
 * Fires on resize/orientationchange only — no scroll listeners.
 */
function setViewportHeightUnit() {
  const vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--vh', `${vh}px`);
}

setViewportHeightUnit();

window.addEventListener('resize', setViewportHeightUnit, { passive: true });
window.addEventListener('orientationchange', setViewportHeightUnit, { passive: true });
